import React, {memo, useState} from 'react';
import GridCell from "./GridCell";
import ListCell from "./ListCell";
import Placeholder from "./Placeholder";

const ProductCell = memo(({
                         listType,
                         isAutoPromoBanners,
                         productPosition,
                         ean,
                         id,
                         rangeLabel,
                         isPei,
                         breadcrumbId,
                         flyerId,
                         getDiscountAti,
                         unitPriceWithoutTax,
                         images,
                         brand,
                         shortTitle,
                         title,
                         productSheetUrl,
                         price,
                         priceWithoutTax,
                         originalPrice,
                         originalPriceWithoutTax,
                         discount,
                         productNote,
                         reviewRate,
                         featuresGroups,
                         ambianceImageInfos,
                         principalImageInfos,
                         commercialSticker,
                         soldBy,
                         offersNumber,
                         offersState,
                         cheapestOfferPrice,
                         cheapestOfferPriceWithoutTax,
                         commercialOperations,
                         productsAvailabilityData,
                         availabilityDisplayMode,
                         availabilityShopIdListFilter,
                         availabilityDataByShops,
                         productIndex,
                         filters,
                         privateSalePrice,
                         privateSalePriceWithoutTax,
                         privateDiscount,
                         metaData,
                         cheapestIsBestOffer,
                         bestOfferSellerName,
                         bestOfferSellerId,
                         maxDisplayedPicto,
                         isPaginationLoading,
                         apiStatusPending,
                         htOptin
                     }) => {
    const {features} = featuresGroups;
    function renderShippingPicto(item) {
        const shippingMethods = item.productListAvailibility?.shippingToCustomerMethods;
        const pictoShippingOffer = shippingMethods?.pictoShippingOffer;
        const relayPointShipping = pictoShippingOffer === "FreeShippingRelayPoint";
        const homeShipping = pictoShippingOffer === "FreeShippingHome";
        const homeRelayPointShipping = pictoShippingOffer === "FreeShippingHome_FreeShippingRelayPoint";
        if (relayPointShipping) {
            return <div className="free-shipping__pickUp">Livraison en point de retrait offerte</div>;
        } else if (homeShipping) {
            return <div className="free-shipping__home">Livraison à domicile offerte</div>;
        } else if (homeRelayPointShipping) {
            return <div className="free-shipping__home">Livraison offerte à domicile et en point de retrait</div>;
        }
        return null;
    };

    function renderShippingPictos() {
        let productAvailability = productsAvailabilityData?.length > 0 ? productsAvailabilityData.filter(product => (product.ean13 == ean)) : null
        return productAvailability?.map(item => (
            <div className="free-shipping" key={item.ean13}>
                {renderShippingPicto(item)}
            </div>
        ));
    };

    const [isHovering, setIsHovering] = useState(false);
    const handleMouseOver = () => {
        setIsHovering(true);
    };
    const handleMouseOut = () => {
        setIsHovering(false);
    };

    const getOffersStateWording = (offersState, offersNumber) => {
        switch (offersState.toLowerCase()) {
            case "neuf" :
                if (offersNumber > 1) {
                    return "offres partenaires neuves"

                } else {
                    return "offre partenaire neuve"
                }
            case "reconditionné" :
                if (offersNumber > 1) {
                    return "offres partenaires reconditionnées"

                } else {
                    return "offre partenaire reconditionnée"
                }
            default :
                return "offres partenaires (neuves et reconditionnées)"
        }
    }

    let reviewRateString = reviewRate.toString();
    let [int, float] = reviewRateString.split('.');
    let isRated = reviewRate ? ' stars-' + int + '-' + (float ? '5' : '0') : '';

    return (
        <>
            {listType === 'grid' &&
                <>
                    {apiStatusPending && !isPaginationLoading ?
                        <Placeholder listType={listType} apiStatusPending={apiStatusPending}/> :
                        <GridCell {...{
                            ean,
                            productPosition,
                            id,
                            rangeLabel,
                            isPei,
                            breadcrumbId,
                            flyerId,
                            getDiscountAti,
                            unitPriceWithoutTax,
                            title,
                            productSheetUrl,
                            commercialOperations,
                            images,
                            commercialSticker,
                            brand,
                            shortTitle,
                            price,
                            priceWithoutTax,
                            originalPrice,
                            originalPriceWithoutTax,
                            discount,
                            isRated,
                            productNote,
                            offersNumber,
                            soldBy,
                            isHovering,
                            handleMouseOver,
                            handleMouseOut,
                            cheapestOfferPrice,
                            cheapestOfferPriceWithoutTax,
                            getOffersStateWording,
                            offersState,
                            availabilityDisplayMode,
                            productsAvailabilityData,
                            availabilityShopIdListFilter,
                            availabilityDataByShops,
                            productIndex,
                            filters,
                            privateSalePrice,
                            privateSalePriceWithoutTax,
                            privateDiscount,
                            metaData,
                            cheapestIsBestOffer,
                            bestOfferSellerName,
                            bestOfferSellerId,
                            maxDisplayedPicto,
                            principalImageInfos, ambianceImageInfos,
                            renderShippingPictos,
                            htOptin
                        }}/>
                    }
                </>
            }

            {listType === 'list' &&
                <>
                    {apiStatusPending &&  isPaginationLoading === false ?
                        <Placeholder apiStatusPending={apiStatusPending}
                                     listType={listType} {...{isAutoPromoBanners}} /> :
                        <ListCell {...{
                            isAutoPromoBanners,
                            ean,
                            productPosition,
                            id,
                            rangeLabel,
                            breadcrumbId,
                            flyerId,
                            getDiscountAti,
                            unitPriceWithoutTax,
                            productSheetUrl,
                            title,
                            handleMouseOver,
                            handleMouseOut,
                            isHovering,
                            images,
                            brand,
                            shortTitle,
                            isRated,
                            productNote,
                            features,
                            commercialOperations,
                            commercialSticker,
                            price,
                            priceWithoutTax,
                            originalPrice,
                            originalPriceWithoutTax,
                            discount,
                            offersNumber,
                            getOffersStateWording,
                            offersState,
                            cheapestOfferPrice,
                            cheapestOfferPriceWithoutTax,
                            productsAvailabilityData,
                            soldBy,
                            availabilityDisplayMode,
                            availabilityShopIdListFilter,
                            availabilityDataByShops,
                            productIndex,
                            filters,
                            privateSalePrice,
                            privateSalePriceWithoutTax,
                            privateDiscount,
                            metaData,
                            maxDisplayedPicto,
                            cheapestIsBestOffer,
                            bestOfferSellerName,
                            bestOfferSellerId,
                            principalImageInfos,
                            ambianceImageInfos,
                            renderShippingPictos,
                            htOptin
                        }}/>
                    }
                </>
            }
        </>
    );
})

export default ProductCell;